<template>
  <button
    class="select-option full-height cursor-pointer text-center round-borders generic-border q-py-lg q-px-lg shadow-1 bg-white"
    :class="{ active, wide }"
    @click="$emit('click', $event)"
  >
    <slot></slot>

    <span class="block q-mt-md q-title text-dark">{{ title }}</span>
    <span v-if="subtitle" class="q-body-1 text-light">{{ subtitle }}</span>
  </button>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      },

      subtitle: {
        type: String
      },

      active: {
        type: Boolean,
        default: false
      },

      wide: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="stylus">
  @import '~variables'

  .select-option
    width: 235px
    &.wide
      width: 300px
    &.active, &:hover
      background-color: $teal-1 !important

  @media (max-width $breakpoint-lg-max)
    .select-option
      width: 100%
</style>
